import { Dic } from "$utils";
export const tableOption = function (that) {
  let deviceMarkList = [];
  Dic.find("SENU087").map((item) => {
    if (item.value == "27" || item.value == "28" || item.value == "29") {
      deviceMarkList.push(item);
    }
  });
  return {
    add: "新增",
    edit: "修改",
    view: "详情",
    emptyText: that.$t("deviceAccess.message.nodata"),
    stripe: true,
    maxHeight: "100%",
    page: true,
    align: "center",
    menuAlign: "center",
    labelSuffix: "：",
    header: false,
    selection: true,
    delBtn: false,
    editBtn: false,
    labelWidth: "106px",
    dialogWidth: "800px",
    column: [
      {
        prop: "check",
        hide: true,
        search: true,
        searchSlot: true
      },
      {
        label: "消防车名称",
        prop: "deviceName",
        overHidden: true,
        search: true,
        editDisplay: true,
        viewDisplay: true,
        addDisplay: true,
        rules: [
          {
            required: true,
            message: "请输入消防车名称",
            trigger: "blur"
          }
        ]
      },
      {
        label: "车牌号",
        prop: "plateNo",
        search: true,
        overHidden: true,
        editDisplay: true,
        viewDisplay: true,
        addDisplay: true,
        rules: [
          {
            required: true,
            message: "请选择车牌号",
            trigger: "blur"
          }
        ]
      },
      {
        label: "所属区域",
        prop: "areaName",
        overHidden: true,
        search: false,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true
      },
      {
        label: "状态",
        prop: "status",
        overHidden: true,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        type: "select",
        dicData: Dic.find("SENU015"),
        formatter: function (row, value) {
          return Dic.findByValue("SENU015", value);
        },
        viewFormatter: (row, value) => {
          return Dic.findByValue("SENU015", value);
        },
        rules: [
          {
            required: true,
            message: "请选择状态",
            trigger: "blur"
          }
        ]
      },
      {
        label: "唯一标识号",
        prop: "thirdDeviceId",
        overHidden: true,
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        search: true,
        rules: [
          {
            required: true,
            message: "请输入唯一标识号",
            trigger: "blur"
          }
        ]
      },
      {
        label: "更新时间",
        prop: "createTime",
        overHidden: true,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true
      },
      {
        label: "车辆描述",
        prop: "thirdDeviceDesc",
        overHidden: true,
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true
      }
    ]
  };
};
